import { tokens } from "../tokens";

// ----------------------------------------------------------------------

const en = {
  [tokens.alerts.attention]: 'Attention',
  [tokens.alerts.error]: 'Error',
  [tokens.alerts.success]: 'Success',
  [tokens.alerts.warning]: 'Warning',
  [tokens.buttons.accept]: 'Accept',
  [tokens.buttons.add]: 'Add',
  [tokens.buttons.addTo]: 'Add to',
  [tokens.buttons.addToAlt]: 'Add to',
  [tokens.buttons.back]: 'Back',
  [tokens.buttons.backHome]: 'Back to Home',
  [tokens.buttons.cancelAndBack]: 'Cancel and go back',
  [tokens.buttons.block]: 'Block',
  [tokens.buttons.bulkEdit]: 'Bulk edit',
  [tokens.buttons.bulkStockEntry]: 'Bulk stock entry',
  [tokens.buttons.cancel]: 'Cancel',
  [tokens.buttons.change]: 'Change',
  [tokens.buttons.checkout]: 'Checkout',
  [tokens.buttons.clear]: 'Clear',
  [tokens.buttons.clearFilter]: 'Clear filters',
  [tokens.buttons.close]: 'Close',
  [tokens.buttons.create]: 'Create',
  [tokens.buttons.confirm]: 'Confirm',
  [tokens.buttons.continue]: 'Continue',
  [tokens.buttons.delete]: 'Delete',
  [tokens.buttons.deliver]: 'Confirm pickup',
  [tokens.buttons.deliverTable]: 'Deliver — {{table}}',
  [tokens.buttons.deliverTableGeneric]: 'Deliver to table',
  [tokens.buttons.edit]: 'Edit',
  [tokens.buttons.editLayout]: 'Edit layout',
  [tokens.buttons.filter]: 'Filter',
  [tokens.buttons.find]: 'Find',
  [tokens.buttons.finish]: 'Finish',
  [tokens.buttons.fulfill]: 'Fulfill',
  [tokens.buttons.invite]: 'Invite',
  [tokens.buttons.new]: 'New',
  [tokens.buttons.newAlt]: 'New',
  [tokens.buttons.operate]: 'Operate',
  [tokens.buttons.next]: 'Next',
  [tokens.buttons.pay]: 'Pay',
  [tokens.buttons.prepare]: 'Prepare',
  [tokens.buttons.previous]: 'Previous',
  [tokens.buttons.print]: 'Print',
  [tokens.buttons.reconnect]: 'Reconnect',
  [tokens.buttons.record]: 'Record',
  [tokens.buttons.rememberAcc]: 'Remember account',
  [tokens.buttons.resendCodeEmail]: 'Resend code',
  [tokens.buttons.resendInvite]: 'Resend invite',
  [tokens.buttons.resendVerifEmail]: 'Resend verification email',
  [tokens.buttons.save]: 'Save',
  [tokens.buttons.search]: 'Search',
  [tokens.buttons.select]: 'Select',
  [tokens.buttons.setReady]: 'Ready for pick up',
  [tokens.buttons.setReadyTable]: 'Ready to deliver',
  [tokens.buttons.show]: 'Show',
  [tokens.buttons.showMore]: 'Show more',
  [tokens.buttons.submit]: 'Submit',
  [tokens.buttons.sync]: 'Sync',
  [tokens.buttons.update]: 'Update',
  [tokens.buttons.upload]: 'Upload',
  [tokens.buttons.validate]: 'Validate',
  [tokens.buttons.validateCheckin]: 'Validate Check-in',
  [tokens.buttons.validateCheckout]: 'Validate Exit',
  [tokens.buttons.useCodeInstead]: 'Use code instead',
  [tokens.buttons.verify]: 'Verify',
  [tokens.buttons.view]: 'View',
  [tokens.buttons.viewQR]: 'View QR Code',
  [tokens.calendar.day]: 'Day',
  [tokens.calendar.week]: 'Week',
  [tokens.calendar.month]: 'Month',
  [tokens.calendar.year]: 'Year',
  [tokens.charts.activeSale]: 'Active Sale',
  [tokens.charts.averagePublic]: 'Average Public',
  [tokens.charts.averageTicket]: 'Average Ticket',
  [tokens.charts.monthlyComparison]: '{{ value }} than last month',
  [tokens.charts.publicDistribution]: 'Public Distribution',
  [tokens.charts.publicAgeDistribution]: 'Public Age Range this',
  [tokens.charts.saleIncome]: 'Sale Income',
  [tokens.charts.salesOverview]: 'Sales Overview',
  [tokens.charts.salesPerVenue]: 'Sales per Venue',
  [tokens.charts.productSalesPerCategory]: 'Products Sold by Category',
  [tokens.charts.productSalesRanking]: 'Product Sales Ranking',
  [tokens.charts.weeklyComparison]: '{{ value }} than last week',
  [tokens.charts.entranceFeeIncome]: 'Entrance Fee Revenue',
  [tokens.charts.entranceFeePerWeekday]: 'Entrance Fee by Weekday',
  [tokens.charts.entranceFeePerVenue]: 'Entrance Fee by Venue',
  [tokens.charts.entranceFeeParticipants]: 'Participants with entrance fee',
  [tokens.charts.entranceFeeAverage]: 'Average entrance fee',
  [tokens.common.all]: 'All',
  [tokens.common.allDone]: 'All done here',
  [tokens.common.allowed]: 'Allowed',
  [tokens.common.authorized]: 'Authorized',
  [tokens.common.browse]: 'Browse',
  [tokens.common.bulk]: 'Bulk',
  [tokens.common.date]: 'Date',
  [tokens.common.dense]: 'Dense',
  [tokens.common.entry]: 'Entry',
  [tokens.common.exit]: 'Exit',
  [tokens.common.history]: 'History',
  [tokens.common.languageChanged]: 'Language changed',
  [tokens.common.loss]: 'Loss',
  [tokens.common.maxSize]: 'Maximum size',
  [tokens.common.me]: 'Me',
  [tokens.common.notAllowed]: 'Not allowed',
  [tokens.common.noData]: 'No data found',
  [tokens.common.notes]: 'Notes',
  [tokens.common.or]: 'or',
  [tokens.common.question]: 'Question',
  [tokens.common.recommended]: 'Recommended',
  [tokens.common.selected]: 'Selected',
  [tokens.common.source]: 'Source',
  [tokens.common.to]: 'to',
  [tokens.common.unauthorized]: 'Unauthorized',
  [tokens.common.with]: 'with',
  [tokens.components.fileUpload.header]: 'Upload file',
  [tokens.components.fileUpload.subStart]: 'Drop file here or click',
  [tokens.components.fileUpload.subEnd]: 'from your computer',
  [tokens.components.photoUpload.header]: 'Upload photos',
  [tokens.components.photoUpload.subStart]: 'Drop photos here or click',
  [tokens.components.photoUpload.subEnd]: 'from your computer',
  [tokens.components.filter]: 'Filter',
  [tokens.components.search]: 'Search',
  [tokens.components.qrCode]: 'QR Code',
  [tokens.components.validatingQrCode]: 'Validating QR Code...',
  [tokens.components.photo]: 'Photo',
  [tokens.controls.created_at]: 'Created at',
  [tokens.controls.created_by]: 'Created by',
  [tokens.controls.orderHistory]: 'Order history',
  [tokens.controls.tabHistory]: 'Tab history',
  [tokens.controls.updated_at]: 'Updated at',
  [tokens.controls.updated_by]: 'Updated by',
  [tokens.fields.address]: 'Address',
  [tokens.fields.addressProof]: 'Proof of Address',
  [tokens.fields.amount]: 'Amount',
  [tokens.fields.area]: 'Area',
  [tokens.fields.bankingProof]: 'Proof of Banking Account',
  [tokens.fields.birthDate]: 'Birthdate',
  [tokens.fields.categoryCode]: 'Category code',
  [tokens.fields.categorySku]: 'Category SKU',
  [tokens.fields.city]: 'City',
  [tokens.fields.code]: 'Code',
  [tokens.fields.comment]: 'Comment',
  [tokens.fields.complement]: 'Complement',
  [tokens.fields.companyContract]: 'Company Contract',
  [tokens.fields.cost]: 'Cost',
  [tokens.fields.country]: 'Country',
  [tokens.fields.description]: 'Description',
  [tokens.fields.discount]: 'Discount',
  [tokens.fields.districtCode]: 'District Code',
  [tokens.fields.districtId]: 'District ID',
  [tokens.fields.drinks]: 'Drinks',
  [tokens.fields.email]: 'Email',
  [tokens.fields.entrance_fee]: 'Entrance Fee',
  [tokens.fields.federalId]: 'Federal ID',
  [tokens.fields.federalIdCard]: 'Federal ID Card',
  [tokens.fields.fiscalRegime]: 'Fiscal Regime',
  [tokens.fields.firstName]: 'First name',
  [tokens.fields.from]: 'From',
  [tokens.fields.food]: 'Food',
  [tokens.fields.gender]: 'Gender',
  [tokens.fields.govId]: 'Government ID',
  [tokens.fields.item]: 'Item',
  [tokens.fields.lastName]: 'Last name',
  [tokens.fields.legalName]: 'Legal Name',
  [tokens.fields.manager]: 'Manager',
  [tokens.fields.min_amount]: 'Minimum Order',
  [tokens.fields.name]: 'Name',
  [tokens.fields.notVerified]: 'Not verified',
  [tokens.fields.number]: 'Number',
  [tokens.fields.openStatus]: 'Open status',
  [tokens.fields.password]: 'Password',
  [tokens.fields.paymentMethod]: 'Payment Method',
  [tokens.fields.payment_mode]: 'Payment Mode',
  [tokens.fields.paymentStatus]: 'Payment Status',
  [tokens.fields.placeholders.description]: 'Quick description of your venue that will be available to your clients...',
  [tokens.fields.placeholders.searchAddress]: 'Type street, number or zip code',
  [tokens.fields.phone]: 'Phone number',
  [tokens.fields.price]: 'Regular Price',
  [tokens.fields.productCode]: 'Product code',
  [tokens.fields.productNcm]: 'Product NCM',
  [tokens.fields.productSku]: 'Product SKU',
  [tokens.fields.profileAvatar]: 'Profile Photo',
  [tokens.fields.quantity]: 'Quantity',
  [tokens.fields.saleprice]: 'Sale price',
  [tokens.fields.sale]: 'Sale',
  [tokens.fields.service_mode]: 'Service Mode',
  [tokens.fields.sku]: 'SKU',
  [tokens.fields.stock]: 'Stock',
  [tokens.fields.stockQuantity]: 'Quantity in stock',
  [tokens.fields.stock_threshold]: 'Stock Threshold',
  [tokens.fields.state]: 'State',
  [tokens.fields.status]: 'Status',
  [tokens.fields.stateId]: 'State ID',
  [tokens.fields.street]: 'Street',
  [tokens.fields.subtotal]: 'Subtotal',
  [tokens.fields.tableNumber]: 'Table Number',
  [tokens.fields.capacity]: 'Capacity',
  [tokens.fields.tabId]: 'Tab Number',
  [tokens.fields.taxes]: 'Service fee',
  [tokens.fields.tip]: 'Tip',
  [tokens.fields.to]: 'To',
  [tokens.fields.total]: 'Total',
  [tokens.fields.netAmount]: 'Estimated net',
  [tokens.fields.processorFee]: 'Card fee (3.99%)',
  [tokens.fields.platformCommission]: 'Check commission',
  [tokens.fields.underVerification]: 'Under verification',
  [tokens.fields.unitCost]: 'Unit cost',
  [tokens.fields.unitPrice]: 'Unit price',
  [tokens.fields.verified]: 'Verified',
  [tokens.fields.venueType]: 'Type',
  [tokens.fields.weekday]: 'Weekday',
  [tokens.fields.zipCode]: 'Zip Code',
  [tokens.gender.female]: 'Female',
  [tokens.gender.male]: 'Male',
  [tokens.gender.other]: 'Other',
  [tokens.gender.unidentified]: 'Unidentified',
  [tokens.helper.higherThan]: '{{ field }} should be higher than {{ value }}',
  [tokens.helper.invalid]: 'Invalid',
  [tokens.helper.invalidDate]: 'Invalid date',
  [tokens.helper.invalidEmail]: 'Must be a valid email address',
  [tokens.helper.invalidGovId]: 'Invalid Government ID',
  [tokens.helper.isRequired]: 'is required',
  [tokens.helper.lowerThan]: '{{ field }} should be lower than {{ value }}',
  [tokens.helper.minChar]: '{{ field }} must be at least {{ count }} characters',
  [tokens.helper.minChar]: '{{ field }} must be at least {{ count }} caracteres',
  [tokens.helper.minLower]: '{{ field }} must be at least {{ count }} lowercase letter',
  [tokens.helper.minNumber]: '{{ field }} must be at least {{ count }} number',
  [tokens.helper.minSymbol]: '{{ field }} must be at least {{ count }} symbol',
  [tokens.helper.minUpper]: '{{ field }} must be at least {{ count }} uppercase letter',
  [tokens.helper.noMatch]: `doesn't match`,
  [tokens.helper.noName]: '{{ field }} must not contain {{ notAllowed }}',
  [tokens.helper.noSeqNumber]: '{{ field }} must not contain sequential numbers',
  [tokens.helper.noSpace]: '{{ field }} must not contain space',
  [tokens.helper.notNegative]: '{{ field }} must not be negative',
  [tokens.helper.underage]: 'Must be 18 or older',
  [tokens.joyride.tour]: 'Restart Tour',
  [tokens.joyride.dashboard.welcome.title]: 'Welcome to the dashboard',
  [tokens.joyride.dashboard.welcome.content]:
    'This is your operational overview. Use the left menu to navigate — only modules allowed for your access profile are shown.',
  [tokens.joyride.dashboard.openVenuesCard.title]: 'Open venues',
  [tokens.joyride.dashboard.openVenuesCard.content]:
    'See which venues are open right now and jump into any unit quickly.',
  [tokens.joyride.dashboard.sessionKpis.title]: 'Live session',
  [tokens.joyride.dashboard.sessionKpis.content]:
    'Track session revenue, active orders, open tabs, and low-stock alerts.',
  [tokens.joyride.dashboard.salesOverviewCard.title]: 'Sales Summary',
  [tokens.joyride.dashboard.salesOverviewCard.content]:
    'View how your consolidated sales are for all your venues.',
  [tokens.joyride.appPage.title]: 'Operations dashboard',
  [tokens.joyride.appPage.content]: 'Shortcut to session KPIs and the operational overview.',
  [tokens.joyride.analyticsPage.title]: 'Analytics',
  [tokens.joyride.analyticsPage.content]:
    'Strategic sales reports and indicators (available based on your plan).',
  [tokens.joyride.tabsPage.title]: 'Tabs',
  [tokens.joyride.tabsPage.content]:
    'Open, track, and close postpaid tabs — built for floor service.',
  [tokens.joyride.inventoryPage.title]: 'Inventory',
  [tokens.joyride.inventoryPage.content]:
    'Manage stock entries, balances, and statements across venues.',
  [tokens.joyride.invoicesPage.title]: 'Invoices',
  [tokens.joyride.invoicesPage.content]: 'Centralized access to invoices from all venues.',
  [tokens.joyride.menuPage.title]: 'Menu',
  [tokens.joyride.menuPage.content]:
    'Categories, products, and menus. Prep-only profiles can browse the catalog here.',
  [tokens.joyride.ordersPage.title]: 'Orders',
  [tokens.joyride.ordersPage.content]:
    'Order list and kanban. Depending on your profile you prepare, deliver, or view only.',
  [tokens.joyride.usersPage.title]: 'Users',
  [tokens.joyride.usersPage.content]:
    'Invite staff, assign access profiles, and choose which venues each person can use.',
  [tokens.joyride.venuesPage.title]: 'Venues',
  [tokens.joyride.venuesPage.content]:
    'Create and edit venues: address, hours, tables, menus, and payment integrations.',
  [tokens.joyride.securityPage.title]: 'Security & profiles',
  [tokens.joyride.securityPage.content]:
    'Review access profiles and the organization permission matrix.',
  [tokens.joyride.billingPage.title]: 'Subscription',
  [tokens.joyride.billingPage.content]:
    'Check plan, billing, and the organization payment portal.',
  [tokens.kpi.ranking]: 'Ranking',
  [tokens.kpi.totalIncome]: 'Total Income',
  [tokens.kpi.entranceFeeIncome]: 'Entrance Fee Revenue',
  [tokens.nav.about]: 'About us',
  [tokens.nav.academy]: 'Academy',
  [tokens.nav.account]: 'Account',
  [tokens.nav.activeOrders]: 'Active Orders',
  [tokens.nav.activeOrdersList]: 'Active Orders List',
  [tokens.nav.app]: 'App',
  [tokens.nav.analytics]: 'Analytics',
  [tokens.nav.auth]: 'Auth',
  [tokens.nav.banking]: 'Banking',
  [tokens.nav.billing]: 'Subscription',
  [tokens.nav.blog]: 'Blog',
  [tokens.nav.booking]: 'Booking',
  [tokens.nav.brokers]: 'Brokers',
  [tokens.nav.browse]: 'Browse',
  [tokens.nav.calendar]: 'Calendar',
  [tokens.nav.canceledOrders]: 'Canceled Orders',
  [tokens.nav.canceledOrdersList]: 'Canceled Orders List',
  [tokens.nav.cards]: 'Cards',
  [tokens.nav.category]: 'Category',
  [tokens.nav.categories]: 'Categories',
  [tokens.nav.categoryList]: 'Categories List',
  [tokens.nav.chat]: 'Chat',
  [tokens.nav.checkout]: 'Checkout',
  [tokens.nav.concepts]: 'Concepts',
  [tokens.nav.contact]: 'Contact',
  [tokens.nav.course]: 'Course',
  [tokens.nav.create]: 'Create',
  [tokens.nav.crypto]: 'Crypto',
  [tokens.nav.customer]: 'Customer',
  [tokens.nav.customers]: 'Customers',
  [tokens.nav.dashboard]: 'Dashboard',
  [tokens.nav.details]: 'Details',
  [tokens.nav.docs]: 'Documentation',
  [tokens.nav.ecommerce]: 'E-Commerce',
  [tokens.nav.economicGroup]: 'Economic Group',
  [tokens.nav.edit]: 'Edit',
  [tokens.nav.error]: 'Error',
  [tokens.nav.feed]: 'Feed',
  [tokens.nav.fileManager]: 'File Manager',
  [tokens.nav.files]: 'Files',
  [tokens.nav.finance]: 'Finance',
  [tokens.nav.fiscal]: 'Fiscal',
  [tokens.nav.payouts]: 'Payouts',
  [tokens.nav.fleet]: 'Fleet',
  [tokens.nav.forgotPassword]: 'Forgot Password',
  [tokens.nav.general]: 'General',
  [tokens.nav.globalMenu]: 'Global Menu',
  [tokens.nav.globalProduct]: 'Global Product',
  [tokens.nav.home]: 'Home',
  [tokens.nav.inactiveOrders]: 'Inactive Orders',
  [tokens.nav.inactiveOrdersList]: 'Inactive Orders List',
  [tokens.nav.inactiveTabs]: 'Inactive Tabs',
  [tokens.nav.inventory]: 'Inventory',
  [tokens.nav.inventoryControl]: 'Inventory Control',
  [tokens.nav.inventoryStatement]: 'Inventory Statement',
  [tokens.nav.invoice]: 'Invoice',
  [tokens.nav.invoiceDetails]: 'Invoice Details',
  [tokens.nav.invoices]: 'Invoices',
  [tokens.nav.invoiceKanban]: 'Invoices Kanban',
  [tokens.nav.invoiceList]: 'Invoices List',
  [tokens.nav.jobList]: 'Job Listings',
  [tokens.nav.kanban]: 'Kanban',
  [tokens.nav.list]: 'List',
  [tokens.nav.login]: 'Login',
  [tokens.nav.logistics]: 'Logistics',
  [tokens.nav.logout]: 'Logout',
  [tokens.nav.mail]: 'Mail',
  [tokens.nav.management]: 'Management',
  [tokens.nav.menu]: 'Menu',
  [tokens.nav.menus]: 'Menus',
  [tokens.nav.notifications]: 'Notifications',
  [tokens.nav.order]: 'Order',
  [tokens.nav.orders]: 'Orders',
  [tokens.nav.orderDetails]: 'Order Details',
  [tokens.nav.orderList]: 'Order List',
  [tokens.nav.ordersKanban]: 'Orders Kanban',
  [tokens.nav.ordersList]: 'Orders List',
  [tokens.nav.organization]: 'Organization',
  [tokens.nav.organizationProfile]: 'Organization details',
  [tokens.nav.overview]: 'Overview',
  [tokens.nav.pages]: 'Pages',
  [tokens.nav.partners]: 'Partners',
  [tokens.nav.payment]: 'Payment',
  [tokens.nav.policies]: 'Policies',
  [tokens.nav.postCreate]: 'Post Create',
  [tokens.nav.postDetails]: 'Post Details',
  [tokens.nav.postList]: 'Post List',
  [tokens.nav.pricing]: 'Pricing',
  [tokens.nav.privacyPolicy]: 'Privacy Policy',
  [tokens.nav.product]: 'Product',
  [tokens.nav.products]: 'Products',
  [tokens.nav.productList]: 'Products List',
  [tokens.nav.profile]: 'Profile',
  [tokens.nav.recoverPassword]: 'Recover password',
  [tokens.nav.register]: 'Register',
  [tokens.nav.reports]: 'Reports',
  [tokens.nav.resetPassword]: 'Reset password',
  [tokens.nav.role]: 'Role',
  [tokens.nav.roles]: 'Roles',
  [tokens.nav.roleList]: 'Roles List',
  [tokens.nav.schedule]: 'Schedule',
  [tokens.nav.timedMenus]: 'Timed menus',
  [tokens.nav.security]: 'Security',
  [tokens.nav.settings]: `Settings`,
  [tokens.nav.signUp]: 'Sign Up',
  [tokens.nav.socialMedia]: 'Social Media',
  [tokens.nav.statement]: 'Statement',
  [tokens.nav.stockEntry]: 'Stock entry',
  [tokens.nav.stockLoss]: 'Stock loss',
  [tokens.nav.supplier]: `Supplier`,
  [tokens.nav.terms]: 'Terms and Conditions',
  [tokens.nav.table]: 'Table',
  [tokens.nav.tables]: 'Tables',
  [tokens.nav.tab]: 'Tab',
  [tokens.nav.tabs]: 'Tabs',
  [tokens.nav.tabDetails]: 'Tab Details',
  [tokens.nav.tabsKanban]: 'Tabs Kanban',
  [tokens.nav.tabsList]: 'Tabs List',
  [tokens.nav.verifyCode]: 'Verify Code',
  [tokens.nav.verifyEmail]: 'Verify Email',
  [tokens.nav.venue]: 'Venue',
  [tokens.nav.venues]: 'Venues',
  [tokens.nav.venueList]: 'Venues List',
  [tokens.nav.venueScheduleTable]: 'Venues Schedules',
  [tokens.nav.user]: 'User',
  [tokens.nav.users]: 'Users',
  [tokens.nav.userList]: 'Users List',

  [tokens.payment.refund.button]: 'Request refund',
  [tokens.payment.refund.confirmTitle]: 'Confirm refund',
  [tokens.payment.refund.confirmMessage]: 'The amount will be returned to the customer via Stripe. This action cannot be undone.',
  [tokens.payment.refund.confirmMessagePix]: 'The amount will be returned to the customer via PIX. This action cannot be undone.',
  [tokens.payment.refund.confirmHint]: 'The refunded amount is what the customer was charged on the card (includes processing and Check fees). Status updates after Stripe confirms. Available for up to 12 hours after payment.',
  [tokens.payment.refund.confirmHintPix]: 'Payment status will update after Woovi confirms the refund. Available for up to 12 hours after payment.',
  [tokens.payment.refund.confirmAction]: 'Refund',
  [tokens.payment.refund.windowHours]: '12 hours',
  [tokens.pages.app.bannerHeader]: 'Welcome back',
  [tokens.pages.app.bannerSubtitle]: `If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything.`,
  [tokens.pages.app.bannerCTA]: 'Show',
  [tokens.pages.app.networkBanner]:
    'You are in the network view: figures add up every venue. To operate a unit — orders, inventory and settings for that venue only — use Operate in the list below or the header selector.',
  [tokens.pages.app.networkBannerCta]: 'View venues',
  [tokens.pages.app.sessionByVenueTitle]: 'Session by venue',
  [tokens.pages.app.sessionByVenueSubtitle]:
    'Live session comparison. Operate enters the unit; the consolidated view stays in the header selector.',
  [tokens.pages.app.metricRevenue]: 'revenue',
  [tokens.pages.app.metricActiveOrders]: 'active orders',
  [tokens.pages.app.metricTabs]: 'tabs',
  [tokens.pages.app.metricAvgTicket]: 'avg ticket',
  [tokens.pages.fastpassCheckout.formHeader]: 'Fastpass Checkout',
  [tokens.pages.fastpassCheckout.formFooterStart]: `By continuing, I confirm I've read and agree with Check's`,
  [tokens.pages.fastpassCheckout.formFooterEnd]: '',
  [tokens.pages.fastpassCheckout.initialFormSubtitle]: 'Enter your CPF and tab number to proceed with the payment.',
  [tokens.pages.fastpassCheckout.paymentCompleteHeader]: 'Thank you for your preference!',
  [tokens.pages.fastpassCheckout.paymentCompleteSubtitle]: 'Your payment was successful! Use the QR Code below to exit the venue.',
  [tokens.pages.fastpassCheckout.paymentFormSubtitle]: 'Pay your tab to generate the QR Code for exit.',
  [tokens.pages.fastpassCheckout.choosePaymentMethod]: 'How would you like to pay?',
  [tokens.pages.fastpassCheckout.payWithCard]: 'Credit card',
  [tokens.pages.fastpassCheckout.payWithPix]: 'PIX',
  [tokens.pages.fastpassCheckout.pixScanHint]: 'Scan the QR Code with your bank app',
  [tokens.pages.fastpassCheckout.pixCopyCode]: 'Copy PIX code',
  [tokens.pages.fastpassCheckout.pixCopied]: 'Code copied!',
  [tokens.pages.fastpassCheckout.pixAwaiting]: 'Awaiting payment confirmation...',
  [tokens.pages.fastpassCheckout.pixExpiredTitle]: 'PIX expired',
  [tokens.pages.fastpassCheckout.pixExpiredMessage]: 'The payment window has expired. Go back and try again.',
  [tokens.pages.fastpassCheckout.cardPaymentError]: 'An unexpected error occurred while processing your payment.',
  [tokens.pages.fastpassCheckout.wantReceiptPrompt]: 'Want a receipt for this payment by email?',
  [tokens.pages.fastpassCheckout.receiptEmailPlaceholder]: 'Your email',
  [tokens.pages.fastpassCheckout.sendReceipt]: 'Send receipt',
  [tokens.pages.fastpassCheckout.receiptSent]: 'Receipt sent! Check your email.',
  [tokens.pages.fastpassCheckout.noOrdersFound]: 'No orders found.',
  [tokens.pages.fastpassCheckout.noOrdersPlaced]: 'No orders placed.',
  [tokens.pages.fastpassCheckout.confirmCloseStep]: 'Confirmation',
  [tokens.pages.fastpassCheckout.confirmTabClose]: 'Confirm tab close',
  [tokens.pages.fastpassCheckout.zeroCloseTitle]: 'Close tab without charge',
  [tokens.pages.fastpassCheckout.zeroCloseMessage]: 'There is no consumption or entrance fee on this tab. Close it without payment?',
  [tokens.pages.fastpassCheckout.zeroCloseHint]: 'No charge will be made.',
  [tokens.pages.fastpassCheckout.zeroCloseFormSubtitle]: 'Confirm tab close to generate your exit QR Code.',
  [tokens.pages.fastpassCheckout.zeroCloseCompleteSubtitle]: 'Tab closed! Use the QR Code below to exit the venue.',
  [tokens.pages.fastpassCheckout.zeroCloseConfirmationFooter]: 'Feel free to contact the venue if you have any questions.',
  [tokens.pages.fastpassCheckout.zeroCloseError]: 'Could not close the tab. Please try again.',
  [tokens.pages.fastpassCheckout.rateLimitedError]: 'Too many attempts. Please wait a few minutes and try again.',
  [tokens.pages.fastpassCheckout.sessionExpiredError]: 'Your session has expired. Please enter your CPF and tab number again.',
  [tokens.pages.fastpassCheckout.tipLabel]: 'Tip',
  [tokens.pages.fastpassCheckout.tipHint]: 'Optional. Added to the total before payment.',
  [tokens.pages.fastpassCheckout.tipNone]: 'No tip',
  [tokens.pages.fastpassCheckout.tipPercent]: '{{percent}}%',
  [tokens.pages.fastpassCheckout.tipCustom]: 'Custom',
  [tokens.pages.fastpassCheckout.tipCustomPlaceholder]: 'Amount',
  [tokens.pages.fastpassCheckout.tipApply]: 'Apply',
  [tokens.pages.fastpassCheckout.tipError]: 'Could not save the tip. Please try again.',
  [tokens.pages.fastpassCheckout.handoffCodeLabel]: 'Your tab code',
  [tokens.pages.fastpassCheckout.copyCode]: 'Copy code',
  [tokens.pages.fastpassCheckout.showCodeAtCounter]: 'Show this code at the counter to pick up your order or exit.',
  [tokens.pages.fastpassCheckout.exitCodeHint]: 'Show this QR code at the exit',
  [tokens.pages.fastpassCheckout.pickupCodeHint]: 'Show this QR code to pick up order #{{order}}',
  [tokens.pages.fastpassCheckout.confirmationFooter]: 'We sent you a confirmation email with your payment details. Feel free to contact the venue if you have any questions.',
  [tokens.pages.forbidden.header]: 'Forbidden access',
  [tokens.pages.forbidden.subtitle]: 'You do not have permission to access this page. Please contact the administrator.',
  [tokens.pages.globalMenu.dialogSubtitle]: `Select products to add to this venue's menu`,
  [tokens.pages.invoice.codeDialogHeader]: 'Enter delivery verification code',
  [tokens.pages.invoice.codeDialogText]: 'Please ask the customer for the 4-digit verification code',
  [tokens.pages.invoice.leftFootnote]: 'This receipt has no tax value',
  [tokens.pages.invoice.reminderDialogAlert] : 'The customer will be notified of the order is',
  [tokens.pages.invoice.reminderDialogHeader]: 'Remind Client',
  [tokens.pages.invoice.reminderDialogSubtitle]: `We can notify the client once again if the order wasn't pick up yet.`,
  [tokens.pages.invoice.reminderDialogText]: 'Do you wish to continue?',
  [tokens.pages.invoice.rightFootnote]: 'suporte@checktech.app',
  [tokens.pages.invoice.updateDialogAlert]: 'The customer will be notified of the',
  [tokens.pages.invoice.updateDialogAlertStrong]: 'updated order status',
  [tokens.pages.invoice.updateDialogHeader]: 'Update Order Status',
  [tokens.pages.invoice.updateDialogText]: 'Please confirm the change to the next status',
  [tokens.pages.order.kanbanSearchPlaceholder]: 'Search by order number or customer…',
  [tokens.pages.order.kanbanSearchEmpty]: 'No orders found',
  [tokens.pages.order.captureRetry]: 'Retry capture',
  [tokens.pages.order.captureRetrySuccess]: 'Payment captured. You can deliver the order.',
  [tokens.pages.order.captureBlockedTitle]: 'Card capture failed. The order was not marked as delivered.',
  [tokens.pages.order.captureWaitingAuth]: 'The customer authorization expired. The order stays blocked until they authorize again in the app.',
  [tokens.pages.order.captureWaitingAuthCta]: 'Waiting for the customer',
  [tokens.pages.order.captureOk]: 'Captured',
  [tokens.pages.login.formHeader]: 'Sign in to Check',
  [tokens.pages.login.formSubtitle]: 'Sign in with your data',
  [tokens.pages.login.noAccountText]: `Don't have an account yet?`,
  [tokens.pages.login.sideBanner]: 'Hi, welcome back!',
  [tokens.pages.maintenance.header]: 'We are under maintenance',
  [tokens.pages.maintenance.subtitle]: 'We are working to improve our services. We will be back soon!',
  [tokens.pages.notFound.header]: 'Page not found',
  [tokens.pages.notFound.subtitle]: 'The page you are looking for does not exist or has been moved. Please check the URL and try again.',
  [tokens.pages.product.details]: 'Product Details',
  [tokens.pages.product.inventoryDescription]: `Set the product's stock threshold so we can let you know when it's running low`,
  [tokens.pages.product.switchDescription]: `Leave off to {{ action }} this product without affecting venues' menus`,
  [tokens.pages.product.pricingAndInventory]: 'Pricing and Inventory',
  [tokens.pages.register.formHeader]: 'Sign up to Check',
  [tokens.pages.register.formSubtitle]: 'Your new cashless e cardless software',
  [tokens.pages.register.formFooterStart]: `By signing up, I confirm I've read and agree with Check's`,
  [tokens.pages.register.formFooterEnd]: '',
  [tokens.pages.register.existingAccountText]: 'Already have an account?',
  [tokens.pages.register.sideBanner]: 'Optimize your operation with Check',
  [tokens.pages.signUp.formHeader]: 'Want to have Check on your Venue?',
  [tokens.pages.signUp.formSubtitle]: `Access is currently limited to invited partners. Join the waitlist bellow. We'll get in touch when is time to optimize your operation!`,
  [tokens.pages.signUp.formFooterStart]: `By joining the waitlist, I confirm I've read and agree with Check's`,
  [tokens.pages.signUp.formFooterEnd]: '',
  [tokens.pages.signUp.existingAccountText]: 'Already have an account?',
  [tokens.pages.signUp.sideBanner]: 'Become a Check Partner!',
  [tokens.pages.resetPwrd.formHeader]: 'Forgot your password?',
  [tokens.pages.resetPwrd.formSubtitle]: `Please type the e-mail associated with your accont and we'll send you a link to reset your password.`,
  [tokens.pages.schedule.formAlert]: 'The venue will automatically open and close to the public with this configuration. You can manually change the open status on tab',
  [tokens.pages.schedule.formHeader]: 'Business Schedule Details',
  [tokens.pages.schedule.formSubtitle]: 'Define your business schedule and client/public service.',
  [tokens.pages.schedule.closesAt]: 'Closes at',
  [tokens.pages.schedule.openUntil]: 'Open until',
  [tokens.pages.schedule.opensAt]: 'Opens at',
  [tokens.pages.timedMenus.title]: 'Timed menus',
  [tokens.pages.timedMenus.subtitle]: 'Choose which categories appear in the app based on operating hours.',
  [tokens.pages.timedMenus.menuName]: 'Menu name',
  [tokens.pages.timedMenus.menuDefault]: 'Default menu',
  [tokens.pages.timedMenus.priority]: 'Priority',
  [tokens.pages.timedMenus.priorityHelp]: 'When schedules overlap, all matching menus are shown in the app. Lower priority appears first.',
  [tokens.pages.timedMenus.menuSchedule]: 'Activation schedules',
  [tokens.pages.timedMenus.menuCategories]: 'Menu categories',
  [tokens.pages.timedMenus.noMenus]: 'No timed menus configured yet.',
  [tokens.pages.timedMenus.addMenu]: 'Add menu',
  [tokens.pages.timedMenus.editMenu]: 'Edit menu',
  [tokens.pages.timedMenus.nameRequired]: 'Menu name is required.',
  [tokens.pages.timedMenus.noSchedulesHint]: 'Add schedules in the Schedule tab before linking.',
  [tokens.pages.timedMenus.noCategoriesHint]: 'Add categories in the Global Menu before linking.',
  [tokens.pages.timedMenus.upgradeRequired]: 'This feature is available on Essential plan or higher.',
  [tokens.pages.timedMenus.upgradeDescription]: 'Timed menus let you show different categories in the app by period (e.g. lunch, happy hour, dinner).',
  [tokens.pages.timedMenus.upgradeCurrentPlan]: 'Your current plan: {{tier}}',
  [tokens.pages.timedMenus.upgradeCta]: 'Manage subscription',

  [tokens.pages.planLock.upgradeCta]: 'Manage subscription',
  [tokens.pages.planLock.upgradeRequired]: 'This feature is available on {{tier}} plan or higher.',
  [tokens.pages.planLock.upgradeCurrentPlan]: 'Your current plan: {{tier}}',
  [tokens.pages.planLock.postpaidLegacy]: 'This venue is still on postpaid. Your current plan cannot open new tabs; switch to prepaid or upgrade to Pro.',
  [tokens.pages.planLock.title.timedMenus]: 'Timed menus',
  [tokens.pages.planLock.title.tableQr]: 'Tables & per-table QR',
  [tokens.pages.planLock.title.analytics]: 'Analytics',
  [tokens.pages.planLock.title.postpaid]: 'Postpaid / tabs',
  [tokens.pages.planLock.title.tabs]: 'Tabs',
  [tokens.pages.planLock.title.inventory]: 'Inventory',
  [tokens.pages.planLock.description.timedMenus]: 'Timed menus let you show different categories in the app by period.',
  [tokens.pages.planLock.description.tableQr]: 'Build your floor layout and generate a QR code per table (Essential or higher).',
  [tokens.pages.planLock.description.analytics]: 'Venue performance reports (Essential or higher).',
  [tokens.pages.planLock.description.postpaid]: 'Postpaid (tab) mode is available on Pro or higher.',
  [tokens.pages.planLock.description.tabs]: 'Manage open tabs at the venue (Pro or higher).',
  [tokens.pages.planLock.description.inventory]: 'Inventory control is available on Pro or higher.',
  [tokens.pages.planLock.featureLost.timedMenus]: 'Timed menus',
  [tokens.pages.planLock.featureLost.tableQr]: 'Per-table QR / layout editing',
  [tokens.pages.planLock.featureLost.analytics]: 'Analytics reports',
  [tokens.pages.planLock.featureLost.postpaid]: 'Postpaid (tab) mode',
  [tokens.pages.planLock.featureLost.tabs]: 'Tabs in the dashboard',
  [tokens.pages.planLock.featureLost.inventory]: 'Inventory',
  [tokens.pages.tab.clientFormHeader]: 'Client Details',
  [tokens.pages.tab.clientFormSubtitle]: 'Fill in the client details to proceed with the tab.',
  [tokens.pages.tab.tableFormBypassButton]: 'Continue without assigning table',
  [tokens.pages.tab.tableFormSubtitle]:
    'Where should orders for this tab be delivered in the venue? (does not change payment splits)',
  [tokens.pages.tab.tableNotAssigned]: 'Table not assigned',
  [tokens.pages.tab.codeDialogHeader]: 'Enter tab verification code',
  [tokens.pages.tab.codeDialogText]: 'Please ask the customer for the 4-digit verification code',
  [tokens.pages.tab.exitCodeDialogText]: 'Enter the tab number and the customer’s 4-digit verification code',
  [tokens.pages.tab.entryQrDialogHeader]: 'Validate Check-in',
  [tokens.pages.tab.entryQrDialogText]: 'Scan the QR code to validate the entry.',
  [tokens.pages.tab.exitQrDialogHeader]: 'Validate Exit',
  [tokens.pages.tab.exitQrDialogText]: 'Scan the exit QR code from the paid tab.',
  [tokens.pages.tab.exitQrIsEntryError]: 'This QR code is for check-in. Use Validate Check-in.',
  [tokens.pages.tab.entryQrIsExitError]: 'This QR code is for exit. Use Validate Exit.',
  [tokens.pages.tab.exitQrIsOrderError]: 'This QR code is for order delivery. Validate it from the order drawer.',
  [tokens.pages.tab.exitQrTabMismatch]: 'The QR code does not match this tab.',
  [tokens.pages.tab.tabIdDigitsOnly]: 'Enter digits only for the tab number',
  [tokens.pages.tab.leftFootnote]: 'This receipt has no tax value',
  [tokens.pages.tab.noOrders]: 'No orders have been placed yet',
  [tokens.pages.tab.kanbanSearchPlaceholder]: 'Search by tab number or customer…',
  [tokens.pages.tab.kanbanSearchEmpty]: 'No tabs match your search',
  [tokens.pages.tab.orderSearchPlaceholder]: 'Search menu…',
  [tokens.pages.tab.orderEmptyMenu]: 'No products available on the active menu',
  [tokens.pages.tab.orderReviewCta]: 'Review',
  [tokens.pages.tab.orderCommentTitle]: 'Item note',
  [tokens.pages.tab.orderCommentPlaceholder]: 'Optional note for the kitchen',
  [tokens.pages.tab.orderReviewTitle]: 'Review order',
  [tokens.pages.tab.orderConfirmCta]: 'Confirm order',
  [tokens.pages.tab.orderSuccessTitle]: 'Order created',
  [tokens.pages.tab.orderSuccessCode]: 'Kitchen code',
  [tokens.pages.tab.orderBackToTab]: 'Back to tab',
  [tokens.pages.tab.orderAnother]: 'New order on this tab',
  [tokens.pages.tab.orderViewDetails]: 'View order',
  [tokens.pages.tab.orderStepMenu]: 'Menu',
  [tokens.pages.tab.orderStepReview]: 'Review',
  [tokens.pages.tab.orderStepDone]: 'Done',
  [tokens.pages.tab.orderNeedsTable]: 'Assign a table to this tab before placing an order.',
  [tokens.pages.tab.orderTabNotOpen]: 'Orders can only be placed on an open tab.',
  [tokens.pages.tab.entranceFee.splitsHeader]: 'Participants',
  [tokens.pages.tab.entranceFee.chargedAtClose]: 'Entrance fee is set when each participant joins and charged at tab close.',
  [tokens.pages.tab.entranceFee.closeTotal]: 'Close total',
  [tokens.pages.tab.entranceFee.entryTotal]: 'Entries',
  [tokens.pages.tab.entranceFee.splitAccepted]: 'Accepted',
  [tokens.pages.tab.entranceFee.splitPending]: 'Pending',
  [tokens.pages.tab.entranceFee.splitAwaitingEntry]: 'Awaiting entry',
  [tokens.pages.tab.entranceFee.splitPresent]: 'Present',
  [tokens.pages.tab.entranceFee.splitPaid]: 'Paid',
  [tokens.pages.tab.entranceFee.splitOther]: 'Other',
  [tokens.pages.tab.entranceFee.newTabLabel]: 'Entry · {{ value }}',
  [tokens.pages.tab.entranceFee.newTabHint]: 'Per participant · current rate · charged at tab close',
  [tokens.pages.tab.entranceFee.processingFee]: 'Processing fee',
  [tokens.pages.tab.paymentProgress.header]: 'Split payment progress',
  [tokens.pages.tab.paymentProgress.paid]: 'Paid so far',
  [tokens.pages.tab.paymentProgress.remaining]: 'Remaining',
  [tokens.pages.tab.paymentProgress.whoPaid]: 'Participants',
  [tokens.pages.tab.paymentProgress.owes]: 'Owes {{amount}}',
  [tokens.pages.tab.minimumTopUp.label]: 'Minimum top-up',
  [tokens.pages.tab.minimumTopUp.hint]: 'The total ({{ current }}) is below the {{ minimum }} minimum. This {{ topUp }} top-up covers the difference.',
  [tokens.pages.tab.minimumTopUp.closeAlertTitle]: 'Tab below minimum',
  [tokens.pages.tab.minimumTopUp.closeAlertMessage]: 'The total ({{ current }}) is below the {{ minimum }} minimum. A top-up of {{ topUp }} will be charged. Total due: {{ payable }}.',
  [tokens.pages.tab.reminderDialogAlert] : 'The customer will be notified of the tab is',
  [tokens.pages.tab.reminderDialogHeader]: 'Remind Client',
  [tokens.pages.tab.reminderDialogSubtitle]: `We can notify the client once again if the tab wasn't closed yet.`,
  [tokens.pages.tab.reminderDialogText]: 'Do you wish to continue?',
  [tokens.pages.tab.rightFootnote]: 'suporte@checktech.app',
  [tokens.pages.tab.updateDialogAlert]: 'The customer will be notified of the',
  [tokens.pages.tab.updateDialogAlertStrong]: 'updated tab status',
  [tokens.pages.tab.updateDialogHeader]: 'Update Tab Status',
  [tokens.pages.tab.updateDialogText]: 'Please confirm the change to the next status',
  [tokens.pages.tab.venueStepHelper]: `Only Venues with Postpaid (Tab) payment mode are displayed.`,
  [tokens.pages.userProfile.general.scheduleSwitch]: `Sync with venue's business schedule`,
  [tokens.pages.userProfile.general.scheduleSwitchTooltip]: `User's access will be disabled during off (closed) hours`,
  [tokens.pages.userProfile.general.scheduleSwitchDisabledTooltip]: 'Unable to sync this user role',
  [tokens.pages.userProfile.general.statusSwitch]: `Inactivate user's access`,
  [tokens.pages.userProfile.general.statusSwitchDisabledTooltip]: `Unable to inactivate your own access`,
  [tokens.pages.userProfile.general.roleDialogHeader]: '{{ role }} Profile Permissions',
  [tokens.pages.userProfile.general.roleDialogSubtitle]: '',
  [tokens.pages.userProfile.security.altHeader]: 'Unable to modify your own access to venues',
  [tokens.pages.userProfile.security.header]: 'Setup which venues {{ name }} can access',
  [tokens.pages.userProfile.security.helper]:
    'People on the right see and operate the unit in the header selector. The organization stays the same; access is per venue.',
  [tokens.pages.userProfile.security.listAltHeader]: 'Authorized Venues',
  [tokens.pages.userProfile.security.listHeader]: 'Unauthorized Venues',
  [tokens.pages.userProfile.invite.venuesHeader]: 'Venues',
  [tokens.pages.userProfile.invite.venuesHelper]:
    'The invite already grants access to these venues. The person can sign in only after setting a password, and in the dashboard they only see the assigned units (header selector and operations). You can change this later on the Security tab.',
  [tokens.pages.userProfile.invite.venuesRequired]: 'Select at least one venue',
  [tokens.pages.userProfile.invite.pending]: 'Invite pending',
  [tokens.pages.userProfile.invite.accepted]: 'Invite accepted',
  [tokens.pages.organizationProfile.helper]:
    'Name and description of the network account. This does not switch organizations — it only edits this one.',
  [tokens.pages.organizationProfile.missingOrg]: 'We could not find the organization for this account.',
  [tokens.pages.userList.removeDialogHeader]: 'Remove from team?',
  [tokens.pages.userList.removeDialogBody]: '{{name}} will lose access to this organization and its venues.',
  [tokens.pages.userList.removeDialogBodyMany]: 'The selected users will lose access to this organization and its venues.',
  [tokens.pages.userList.removeDialogNote]: 'Full deletion of the Check account must be requested by the user.',
  [tokens.pages.venues.noData]: 'No venues found',
  [tokens.pages.venues.noDataTitle]: 'Start by registering your first!',
  [tokens.pages.venues.overLimitBanner]: 'You have {{count}} active venues, but the {{tier}} plan allows up to {{limit}}. Upgrade your plan or deactivate a venue in its settings.',
  [tokens.pages.venues.overLimitShort]: 'Venue limit exceeded',
  [tokens.pages.venues.overLimitTooltip]: 'Venue limit exceeded. Upgrade your plan or deactivate a venue to fix it.',
  [tokens.pages.venues.overLimitCta]: 'Manage subscription',
  [tokens.pages.venues.overLimitViewCta]: 'View venues',
  [tokens.pages.venues.networkHelpTitle]: 'Organization and venue',
  [tokens.pages.venues.networkHelp]:
    'The organization is the network account. Each venue has its own operation. This list registers and configures units. To operate one of them (orders, inventory, settings for that venue only), use the header selector.',
  [tokens.pages.venues.bulkEditDialogHeader]: 'Change Selected Venues',
  [tokens.pages.venues.bulkEditDialogSubtitle]: 'Please select which fields you want to update for all selected venues and set the desired status.',
  [tokens.pages.venueProfile.readOnlyBanner]:
    'You can view this venue, but you do not have permission to edit it.',
  [tokens.pages.venueProfile.docs.header]: 'Documentation for verification',
  [tokens.pages.venueProfile.docs.subtitle]: 'Send the required documentation to verify the venue',
  [tokens.pages.venueProfile.fiscal.header]: 'Fiscal Details',
  [tokens.pages.venueProfile.fiscal.addressCheck]: 'Registered Address',
  [tokens.pages.venueProfile.fiscal.addressCheckSub]: 'Use same as business address',
  [tokens.pages.venueProfile.payouts.header]: 'Payouts',
  [tokens.pages.venueProfile.payouts.subtitle]: 'Activate payouts to receive payments processed by Check directly into your bank account',
  [tokens.pages.venueProfile.payouts.statusNotConnected]: 'Not activated',
  [tokens.pages.venueProfile.payouts.statusOnboarding]: 'In progress',
  [tokens.pages.venueProfile.payouts.statusActive]: 'Active',
  [tokens.pages.venueProfile.payouts.statusReady]: 'Ready',
  [tokens.pages.venueProfile.payouts.statusRestricted]: 'Restricted',
  [tokens.pages.venueProfile.payouts.notConnectedBody]: 'Complete the setup to start receiving payments from your orders and tabs directly into your account.',
  [tokens.pages.venueProfile.payouts.onboardingBody]: 'Finish Stripe setup to activate payouts for this venue.',
  [tokens.pages.venueProfile.payouts.activeBody]: 'Check payments are settling to your Connect account. Open the Stripe dashboard for balance, payouts and bank details.',
  [tokens.pages.venueProfile.payouts.readyBody]:
    'Stripe onboarding is complete. Turn on the switch below to settle Check payments to this venue’s Connect account.',
  [tokens.pages.venueProfile.payouts.restrictedBody]: 'There are pending items that need to be resolved to keep payouts active. Continue setup to complete the information.',
  [tokens.pages.venueProfile.payouts.cta]: 'Activate payouts',
  [tokens.pages.venueProfile.payouts.continueCta]: 'Continue setup',
  [tokens.pages.venueProfile.payouts.manageCta]: 'Manage setup',
  [tokens.pages.venueProfile.payouts.setupTitle]: 'Activate payouts',
  [tokens.pages.venueProfile.payouts.openDashboard]: 'Open Stripe dashboard',
  [tokens.pages.venueProfile.payouts.fiscalRequired]: 'Complete the fiscal data (legal name and CNPJ) on the Fiscal tab before activating payouts.',
  [tokens.pages.venueProfile.payouts.invalidCnpj]: 'Invalid CNPJ: it must have exactly 14 digits. Open the Fiscal tab, fix the CNPJ, and save before activating.',
  [tokens.pages.venueProfile.payouts.sideHeader]: 'Account details',
  [tokens.pages.venueProfile.payouts.accountId]: 'Account ID',
  [tokens.pages.venueProfile.payouts.feeLabel]: 'Platform fee',
  [tokens.pages.venueProfile.payouts.requirementsLabel]: 'Pending items',
  [tokens.pages.venueProfile.payouts.noRequirements]: 'No pending items',
  [tokens.pages.venueProfile.payouts.footer]: 'Payouts are processed by Stripe.',
  [tokens.pages.venueProfile.payouts.genericError]: 'Could not load payouts data. Please try again.',
  [tokens.pages.venueProfile.payouts.confirmTitle]: 'Confirm payout activation',
  [tokens.pages.venueProfile.payouts.confirmIntro]:
    'By confirming, we will send the data below to Stripe to create this venue’s payout account. Please review it before continuing.',
  [tokens.pages.venueProfile.payouts.confirmDataHeader]: 'Data that will be sent',
  [tokens.pages.venueProfile.payouts.confirmNextStep]:
    'Next, you will finish setup in Stripe (bank details and verification). Check payments will be paid out to the bank account you provide.',
  [tokens.pages.venueProfile.payouts.confirmContactEmailNote]:
    'The email on your Check account will be used as the contact email with Stripe.',
  [tokens.pages.venueProfile.payouts.confirmAddressFromVenue]: 'Operating address',
  [tokens.pages.venueProfile.payouts.confirmAddressFromFiscal]: 'Fiscal address',
  [tokens.pages.venueProfile.payouts.confirmMissingValue]: 'Not provided',
  [tokens.pages.venueProfile.payouts.settlementToggle]: 'Settle to Connect account',
  [tokens.pages.venueProfile.payouts.settlementToggleHelp]:
    'When on, Check payments settle to this venue’s Stripe account. When off, settlement stays on the platform legacy path.',
  [tokens.pages.venueProfile.payouts.settlementToggleBlocked]:
    'Finish Stripe onboarding (charges enabled) before turning this on.',
  [tokens.pages.venueProfile.payouts.settlementOn]: 'Connect settlement enabled',
  [tokens.pages.venueProfile.payouts.settlementOff]: 'Connect settlement disabled',
  [tokens.pages.venueProfile.payouts.reqGroup.business]: 'Business profile',
  [tokens.pages.venueProfile.payouts.reqGroup.company]: 'Company details',
  [tokens.pages.venueProfile.payouts.reqGroup.directors]: 'Directors',
  [tokens.pages.venueProfile.payouts.reqGroup.executives]: 'Executives',
  [tokens.pages.venueProfile.payouts.reqGroup.owners]: 'Owners',
  [tokens.pages.venueProfile.payouts.reqGroup.representative]: 'Legal representative',
  [tokens.pages.venueProfile.payouts.reqGroup.individual]: 'Individual',
  [tokens.pages.venueProfile.payouts.reqGroup.bank]: 'Bank account & terms',
  [tokens.pages.venueProfile.payouts.reqGroup.other]: 'Other information',
  [tokens.pages.venueProfile.payouts.reqField.productDescription]: 'Product / service description',
  [tokens.pages.venueProfile.payouts.reqField.businessName]: 'Business name',
  [tokens.pages.venueProfile.payouts.reqField.mcc]: 'Business category',
  [tokens.pages.venueProfile.payouts.reqField.url]: 'Website or social profile',
  [tokens.pages.venueProfile.payouts.reqField.supportPhone]: 'Support phone',
  [tokens.pages.venueProfile.payouts.reqField.supportEmail]: 'Support email',
  [tokens.pages.venueProfile.payouts.reqField.directorsProvided]: 'Director details',
  [tokens.pages.venueProfile.payouts.reqField.executivesProvided]: 'Executive details',
  [tokens.pages.venueProfile.payouts.reqField.ownersProvided]: 'Owner details',
  [tokens.pages.venueProfile.payouts.reqField.taxId]: 'Tax ID',
  [tokens.pages.venueProfile.payouts.reqField.phone]: 'Phone',
  [tokens.pages.venueProfile.payouts.reqField.email]: 'Email',
  [tokens.pages.venueProfile.payouts.reqField.fullName]: 'Full name',
  [tokens.pages.venueProfile.payouts.reqField.idNumber]: 'Government ID',
  [tokens.pages.venueProfile.payouts.reqField.politicalExposure]: 'Political exposure',
  [tokens.pages.venueProfile.payouts.reqField.jobTitle]: 'Job title',
  [tokens.pages.venueProfile.payouts.reqField.idDocument]: 'Identity document',
  [tokens.pages.venueProfile.payouts.reqField.additionalDocument]: 'Additional document',
  [tokens.pages.venueProfile.payouts.reqField.address]: 'Address',
  [tokens.pages.venueProfile.payouts.reqField.dob]: 'Date of birth',
  [tokens.pages.venueProfile.payouts.reqField.relationship]: 'Relationship to company',
  [tokens.pages.venueProfile.payouts.reqField.verification]: 'Identity verification',
  [tokens.pages.venueProfile.payouts.reqField.bankAccount]: 'Bank account',
  [tokens.pages.venueProfile.payouts.reqField.percentOwnership]: 'Ownership percentage',
  [tokens.pages.venueProfile.payouts.reqField.relationshipExecutive]: 'Confirmed as executive',
  [tokens.pages.venueProfile.payouts.reqField.relationshipOwner]: 'Confirmed as owner',
  [tokens.pages.venueProfile.payouts.reqField.relationshipDirector]: 'Confirmed as director',
  [tokens.pages.venueProfile.payouts.reqField.tosAcceptance]: 'Terms acceptance',
  [tokens.pages.venueProfile.payouts.reqField.tosDate]: 'Terms acceptance date',
  [tokens.pages.venueProfile.payouts.reqField.tosIp]: 'Terms acceptance IP',
  [tokens.pages.venueProfile.general.header]: 'Basic Details',
  [tokens.pages.venueProfile.general.entrance_feeSub]: 'Default per-person entrance fee for postpaid tabs (fallback when a weekday has no override). Current default: R$ {{ value }}',
  [tokens.pages.venueProfile.general.entrance_feeWeekdayHeader]: 'Fee by weekday',
  [tokens.pages.venueProfile.general.entrance_feeWeekdaySub]: 'Optional override per day. Leave blank to use the default (R$ {{ value }}).',
  [tokens.pages.venueProfile.general.entrance_feeWeekdayPlaceholder]: 'Default',
  [tokens.pages.venueProfile.general.entrance_feeWeekdayAfterCreate]: 'Save the venue first to configure weekday overrides.',
  [tokens.pages.venueProfile.general.entrance_feePrepaidDisabled]: 'Entrance fee applies only to postpaid (tab) venues.',
  [tokens.pages.venueProfile.general.entrance_feeCurrent]: 'Current fee if someone joined now: {{ value }}',
  [tokens.pages.venueProfile.general.openstatusSwitch]: 'Manually open venue to the public',
  [tokens.pages.venueProfile.general.openstatusSwitchTooltip]: 'When open the public can check-in and send orders',
  [tokens.pages.venueProfile.general.openstatusSwitchStatusTooltip]: 'Turn on venue Status before opening to the public',
  [tokens.pages.venueProfile.general.openstatusSwitchReceivingTooltip]: 'Set up and enable receiving (Connect) under Payouts before opening',
  [tokens.pages.venueProfile.general.payment_modeSub]: 'Payment mode for this venue',
  [tokens.pages.venueProfile.general.service_modeSub]:
    'Table = delivery destination on the floor. Tabs and splits stay individual in the app — there is no shared “table check”.',
  [tokens.pages.venueProfile.general.statusSwitch]: 'Apply to make this venue viewable to the public',
  [tokens.pages.venueProfile.general.statusSwitchTooltip]: 'When active the venue is visible to the public',
  [tokens.pages.venueProfile.general.statusSwitchAltTooltip]: 'Only verified venues are viewable to the public',
  [tokens.pages.venueProfile.general.statusSwitchLimitTooltip]: 'Your plan allows up to {{limit}} active venues at a time — upgrade or deactivate another to activate this one',
  [tokens.pages.venueProfile.general.statusSwitchLimitCaption]: 'Limit of {{limit}} active venues on the {{tier}} plan reached. Upgrade or deactivate another venue.',
  [tokens.pages.venueProfile.general.settingsHeader]: 'Basic Settings',
  [tokens.pages.venueProfile.general.min_amountSub]: 'Minimum order amount (standard R$ {{ value }})',
  [tokens.pages.venueProfile.menu.productDialog.subtitle]: 'Set an specific regular price, sales price and stock quantity to this venue',
  [tokens.pages.venueProfile.layout.header]: 'Table Layout',
  [tokens.pages.venueProfile.layout.sub]:
    'List or map: QR, status, and table setup. Edit layout for floor-plan position and add/remove. They do not group tabs.',
  [tokens.pages.venueProfile.inventory.entryDialog.subtitle]: 'Record a stock product entry',
  [tokens.pages.venueProfile.inventory.historyDialog.subtitle]: 'History of stock entry and exit per',
  [tokens.pages.venueProfile.security.altHeader]: 'Unable to modify your own access to venues',
  [tokens.pages.venueProfile.security.header]: 'Users with access to this venue',
  [tokens.pages.venueProfile.security.helper]:
    'Only people on the right operate this unit. Staff without access will not see the venue in the header selector. On the person’s profile, the Security tab does the same assignment.',
  [tokens.pages.venueProfile.security.listAltHeader]: 'Authorized Users',
  [tokens.pages.venueProfile.security.listHeader]: 'Unauthorized Users',
  [tokens.pages.verifyCode.formHeader]: 'Code successfully sent!',
  [tokens.pages.verifyCode.formSubtitleStart]: 'We sent a 6-digit code to your email',
  [tokens.pages.verifyCode.formSubtitleEnd]: 'Type the code below to reset your password.',
  [tokens.pages.verifyCode.formFooter]: `Didn't receive the code?`,
  [tokens.pages.verifiedEmail.header]: 'Email successfully verified!',
  [tokens.payment_modes.postpaid]: 'Postpaid (Tab)',
  [tokens.payment_modes.prepaid]: 'Prepaid (Order)',
  [tokens.popover.tenant.header]: 'Focused Management',
  [tokens.popover.tenant.subtitle]: 'Select a venue to see its environment',
  [tokens.popover.tenant.generalTitle]: 'Global Management',
  [tokens.popover.tenant.viewOrganization]: 'View entire organization',
  [tokens.tenantContext.showingVenue]: 'Showing: {{name}}',
  [tokens.tenantContext.showingOrganization]: 'Showing: {{count}} venues',
  [tokens.tenantContext.onboardingMessage]: 'You manage {{count}} venues. Use this selector to switch between the organization-wide view and a single venue at a time.',
  [tokens.tenantContext.onboardingCta]: 'Got it',
  [tokens.tenantContext.searchPlaceholder]: 'Search venue…',
  [tokens.tenantContext.recent]: 'Recent',
  [tokens.tenantContext.openOrdersCount]: '{{count}} open orders',
  [tokens.tenantContext.closed]: 'Closed',
  [tokens.tenantContext.noResults]: 'No venue found',
  [tokens.tenantContext.currentPlan]: 'Current plan',
  [tokens.tenantContext.venueLimitUsage]: '{{count}} of {{limit}} venues',
  [tokens.tenantContext.venueLimitUsageUnlimited]: '{{count}} venues · no limit',
  [tokens.security.viewAllProfiles]: 'View all',
  [tokens.security.userCount_one]: '{{count}} user',
  [tokens.security.userCount_other]: '{{count}} users',
  [tokens.security.noUsersOnProfile]: 'No users on this profile',
  [tokens.roles.admin]: 'Admin',
  [tokens.roles.bar]: 'Bar',
  [tokens.roles.bartender]: 'Bar',
  [tokens.roles.cook]: 'Kitchen',
  [tokens.roles.finance]: 'Finance',
  [tokens.roles.investor]: 'Investor',
  [tokens.roles.kitchen]: 'Kitchen',
  [tokens.roles.manager]: 'Manager',
  [tokens.roles.waiter]: 'Waiter',
  [tokens.shortpayment_modes.postpaid]: 'Tab',
  [tokens.shortpayment_modes.prepaid]: 'Order',
  [tokens.shortservice_modes.counter]: 'Counter',
  [tokens.shortservice_modes.hybrid]: 'Hybrid',
  [tokens.shortservice_modes.table]: 'Table',
  [tokens.service_modes.counter]: 'Counter Service',
  [tokens.service_modes.hybrid]: 'Hybrid Service',
  [tokens.service_modes.table]: 'Table Service',
  [tokens.settings.themeMode]: 'Mode',
  [tokens.snackbar.codeSent.error]: 'Error while sending code',
  [tokens.snackbar.codeSent.success]: 'Code sent successfully!',
  [tokens.snackbar.codeValidation.error]: 'Error while validating code',
  [tokens.snackbar.codeValidation.success]: 'Code validated successfully!',
  [tokens.snackbar.create.error]: 'Error while creating',
  [tokens.snackbar.create.success]: 'Successfully created!',
  [tokens.snackbar.createTab.error.existingAnotherVenue]: 'Cannot create tab while another venue is open',
  [tokens.snackbar.createTab.error.existingSameVenue]: 'User already have an open tab in this venue',
  [tokens.snackbar.createTab.error.payment_modeMismatch]: 'Cannot create tab in a venue with prepaid payment mode',
  [tokens.snackbar.createTab.error.venueClosed]: 'Cannot create tab in a closed venue',
  [tokens.snackbar.createTab.error.venueDenied]: 'Cannot create tab in a denied venue',
  [tokens.snackbar.createTab.error.venueInactive]: 'Cannot create tab in an inactive venue',
  [tokens.snackbar.createTab.success]: 'Tab successfully created!',
  [tokens.snackbar.delete.error]: 'Error while deleting',
  [tokens.snackbar.delete.success]: 'Successfully deleted!',
  [tokens.snackbar.entryValidation.error]: 'Error while validating entry',
  [tokens.snackbar.entryValidation.success]: 'Entry validated successfully!',
  [tokens.snackbar.exitValidation.error]: 'Error while validating exit',
  [tokens.snackbar.exitValidation.success]: 'Exit validated successfully!',
  [tokens.snackbar.fetch.error]: 'Error while fetching data',
  [tokens.snackbar.fetch.success]: 'Data fetched successfully!',
  [tokens.snackbar.fileUpload.error]: 'Error while uploading file',
  [tokens.snackbar.fileUpload.success]: 'File uploaded successfully!',
  [tokens.snackbar.inventoryEntry.error]: 'Error while recording stock entry',
  [tokens.snackbar.inventoryEntry.success]: 'Stock entry successfully recorded!',
  [tokens.snackbar.inventoryLoss.error]: 'Error while recording stock loss',
  [tokens.snackbar.inventoryLoss.success]: 'Stock loss successfully recorded!',
  [tokens.snackbar.notification.error]: 'Error while sending notification',
  [tokens.snackbar.notification.success]: 'Notification successfully sent!',
  [tokens.snackbar.passwordChange.error]: 'Error while changing password',
  [tokens.snackbar.passwordChange.success]: 'Successfully changed password!',
  [tokens.snackbar.resetPassword.error]: 'Error while reseting password',
  [tokens.snackbar.resetPassword.success]: 'Password successfully reseted!',
  [tokens.snackbar.resetPasswordEmail.error]: 'Error while sending email to reset password',
  [tokens.snackbar.resetPasswordEmail.success]: 'Password reset email successfully sent to {{ email }}',
  [tokens.snackbar.resendInvite.error]: 'Error while resending the invite',
  [tokens.snackbar.resendInvite.success]: 'Invite resent to {{ email }}',
  [tokens.snackbar.refund.error]: 'Could not process the refund',
  [tokens.snackbar.refund.success]: 'Refund requested successfully',
  [tokens.snackbar.refund.windowExpired]: 'Refund window expired (12 hours after payment)',
  [tokens.snackbar.signUp.error]: 'Error while joining waitlist',
  [tokens.snackbar.signUp.success]: 'Waitlist successfully joined!',
  [tokens.snackbar.update.error]: 'Error while updating data',
  [tokens.snackbar.update.success]: 'Data successfully updated!',
  [tokens.snackbar.update.venueActivatePlanLimit]: 'Active venue plan limit reached',
  [tokens.snackbar.update.venueOpenStatusRequired]: 'Venue must be active before opening to the public',
  [tokens.snackbar.update.venueOpenVerifiedRequired]: 'Venue must be verified before opening to the public',
  [tokens.snackbar.update.venueOpenReceivingRequired]: 'Set up and enable receiving (Connect) before opening',
  [tokens.snackbar.update.venueBulkAccessDenied]: 'No permission to edit one or more venues',
  [tokens.snackbar.verifyEmail.error]: 'Error while sending email verification',
  [tokens.snackbar.verifyEmail.success]: 'Email verification successfully sent to {{ email }}',
  [tokens.status.label.active]: 'Active',
  [tokens.status.label.analyzing]: 'In analysis',
  [tokens.status.label.approved]: 'Approved',
  [tokens.status.label.canceled]: 'Canceled',
  [tokens.status.label.closed]: 'Closed',
  [tokens.status.label.closing]: 'Closing',
  [tokens.status.label.completed]: 'Completed',
  [tokens.status.label.connected]: 'Connected',
  [tokens.status.label.declined]: 'Declined',
  [tokens.status.label.disconnected]: 'Disconnected',
  [tokens.status.label.fulfilled]: 'Fulfilled',
  [tokens.status.label.inactive]: 'Inactive',
  [tokens.status.label.inStock]: 'In Stock',
  [tokens.status.label.lowStock]: 'Low Stock',
  [tokens.status.label.onSale]: 'On Sale',
  [tokens.status.label.open]: 'Open',
  [tokens.status.label.opened]: 'Opened',
  [tokens.status.label.outOfStock]: 'Out of Stock',
  [tokens.status.label.paid]: 'Paid',
  [tokens.status.label.paymentPending]: 'Payment Pending',
  [tokens.status.label.paymentReceived]: 'Payment Received',
  [tokens.status.label.paymentRefunded]: 'Payment Refunded',
  [tokens.status.label.paymentRejected]: 'Payment Rejected',
  [tokens.status.label.paymentFailed]: 'Payment Failed',
  [tokens.status.label.pending]: 'Pending',
  [tokens.status.label.preparing]: 'Preparing',
  [tokens.status.label.ready]: 'Ready for pick up',
  [tokens.status.label.readyGeneric]: 'Ready',
  [tokens.status.label.readyTable]: 'Ready to deliver',
  [tokens.status.label.readyTableGeneric]: 'Ready to deliver',
  [tokens.status.label.received]: 'Received',
  [tokens.status.label.reconnecting]: 'Reconnecting',
  [tokens.status.label.sent]: 'Sent',
  [tokens.status.step.cancel]: 'Cancel',
  [tokens.status.step.complete]: 'Complete',
  [tokens.status.step.finishPrep]: 'Finish preparing',
  [tokens.status.step.receive]: 'Receive',
  [tokens.status.step.startPrep]: 'Start preparing',
  [tokens.status.stepAction.delivered]: 'Delivered to client',
  [tokens.status.stepAction.finishedPreparation]: 'Finished preparation',
  [tokens.status.stepAction.orderCanceled]: 'Order canceled',
  [tokens.status.stepAction.orderDelivered]: 'Order delivered',
  [tokens.status.stepAction.orderDeliveredToTable]: 'Order delivered ({{table}})',
  [tokens.status.stepAction.orderReceived]: 'Order received',
  [tokens.status.stepAction.orderRefunded]: 'Order refunded',
  [tokens.status.stepAction.paid]: 'Payment received',
  [tokens.status.stepAction.paymentFailed]: 'Payment failed',
  [tokens.status.stepAction.paymentRefunded]: 'Payment refunded',
  [tokens.status.stepAction.startedClosing]: 'Started closing',
  [tokens.status.stepAction.startedPreparation]: 'Started preparation',
  [tokens.status.stepAction.tabCanceled]: 'Tab canceled',
  [tokens.status.stepAction.tabFulfilled]: 'Tab fulfilled',
  [tokens.status.stepAction.tabPaid]: 'Tab paid',
  [tokens.status.stepAction.tabRefunded]: 'Tab refunded',
  [tokens.status.stepAction.tabOpened]: 'Tab opened',
  [tokens.tables.openVenues]: 'Open Venues',
  [tokens.tables.noOpenVenues]: 'No Open Venues',
  [tokens.tables.productRanking]: 'Product Ranking',
  [tokens.tables.emptyLayout]: 'No tables yet. Add tables to build your floor plan.',
  [tokens.tables.viewList]: 'List',
  [tokens.tables.viewMap]: 'Map',
  [tokens.tables.qrAfterSave]: 'The QR code becomes available after the table is saved.',
  [tokens.tables.addMultiplePrompt]: 'How many tables do you want to add?',
  [tokens.tables.invalidateQr]: 'Invalidate QR',
  [tokens.tables.invalidateQrConfirm]:
    'Invalidate this QR code? The current code will stop working and a new one will be generated.',
  [tokens.tables.assignRequired]:
    'This venue uses table delivery. Select where to deliver orders for this tab. (does not change payment splits)',
  [tokens.tables.assignOptional]:
    'Where should orders for this tab be delivered on the floor? (does not change payment splits)',
  [tokens.tables.assignDialog]: 'Assign table',
  [tokens.tables.changeTable]: 'Change table',
  [tokens.tables.clearTable]: 'Remove table',
  [tokens.tables.deliveryHint]: 'Delivery location',
  [tokens.tables.openExistingTab]: 'View tab #{{id}}',
  [tokens.tables.status.available]: 'Available',
  [tokens.tables.status.occupied]: 'Occupied',
  [tokens.tables.status.reserved]: 'Reserved',
  [tokens.tables.status.disabled]: 'Disabled',
  [tokens.tags.containsAlcohol]: 'Contains alcohol',
  [tokens.tags.nonAlcoholic]: 'Non-alcoholic',
  [tokens.tags.type]: 'Type',
  [tokens.venueTypes.bar]: 'Bar',
  [tokens.venueTypes.events]: 'Events',
  [tokens.venueTypes.nightClub]: 'Night Club',
  [tokens.venueTypes.restaurant]: 'Restaurant',
  [tokens.weekdays.monday]: 'Monday',
  [tokens.weekdays.tuesday]: 'Tuesday',
  [tokens.weekdays.wednesday]: 'Wednesday',
  [tokens.weekdays.thursday]: 'Thursday',
  [tokens.weekdays.friday]: 'Friday',
  [tokens.weekdays.saturday]: 'Saturday',
  [tokens.weekdays.sunday]: 'Sunday',

  [tokens.pages.billing.currentPlan]: 'Current plan',
  [tokens.pages.billing.venueLimit]: 'Up to {{count}} venues',
  [tokens.pages.billing.venueLimitUnlimited]: 'Unlimited venues',
  [tokens.pages.billing.venueLimitOne]: 'Up to 1 venue',
  [tokens.pages.billing.nextRenewal]: 'Next renewal',
  [tokens.pages.billing.noRenewal]: 'No renewal scheduled',
  [tokens.pages.billing.venueUsage]: '{{active}} of {{limit}} venues',
  [tokens.pages.billing.venueUsageUnlimited]: '{{active}} venues (unlimited)',
  [tokens.pages.billing.cancelAtPeriodEnd]: 'Cancels at period end',
  [tokens.pages.billing.cancelAtPeriodEndHint]: 'After this date, the plan becomes {{tier}}',
  [tokens.pages.billing.managePortal]: 'Manage payment / invoices',
  [tokens.pages.billing.refresh]: 'Refresh',
  [tokens.pages.billing.refreshTooltip]: 'Refresh subscription status',
  [tokens.pages.billing.adminsOnly]: 'Only organization admins can manage the subscription.',
  [tokens.pages.billing.changePlan]: 'Change plan',
  [tokens.pages.billing.subscribePlan]: 'Subscribe to a plan',
  [tokens.pages.billing.monthly]: 'Monthly',
  [tokens.pages.billing.annual]: 'Annual',
  [tokens.pages.billing.perMonth]: '/mo',
  [tokens.pages.billing.perYear]: '/yr',
  [tokens.pages.billing.free]: 'Free',
  [tokens.pages.billing.onRequest]: 'Contact us',
  [tokens.pages.billing.feesLine]: '+ {{card}}% card · {{pix}}% PIX',
  [tokens.pages.billing.processing]: 'Processing…',
  [tokens.pages.billing.pleaseWait]: 'Please wait…',
  [tokens.pages.billing.contactUs]: 'Contact us',
  [tokens.pages.billing.policyFootnote]:
    'Upgrade and monthly→annual: delta charged now (you confirm the amount first). Downgrade and annual→monthly: no refund; changes next cycle. Back to Starter: cancellation portal.',
  [tokens.pages.billing.pastDueAlert]:
    'Payment past due. Update your card in the portal (3-day grace) to keep the {{tier}} plan.',
  [tokens.pages.billing.pastDueUpdatePayment]: 'Update payment',
  [tokens.pages.billing.incompleteAlert]:
    'Subscription payment is incomplete (card not confirmed or extra authentication pending). Finish payment in the portal before changing plans if the upgrade fails.',
  [tokens.pages.billing.incompleteCompletePayment]: 'Complete payment',
  [tokens.pages.billing.pendingDowngradeAlert]:
    'Downgrade scheduled to {{pending}} on {{date}}. You stay on {{current}} until then.',
  [tokens.pages.billing.pendingVenueExcess]:
    'Your {{pending}} plan allows up to {{limit}} active venue(s). You have {{active}}. Deactivate at least {{excess}} by {{date}}; otherwise we will auto-deactivate {{excess}} (random selection).',
  [tokens.pages.billing.enforceDeactivatedAlert]:
    'We deactivated {{count}} venue(s) to fit the {{tier}} plan. You can reactivate up to the limit or upgrade.',
  [tokens.pages.billing.globalPastDueAlert]:
    'We could not process payment for the {{tier}} plan. Update your payment method within {{days}} to keep your plan.',
  [tokens.pages.billing.globalPastDueDays]: '{{count}} days',
  [tokens.pages.billing.globalPastDueToday]: 'today',
  [tokens.pages.billing.globalPastDueOneDay]: '1 day',
  [tokens.pages.billing.locked.title]: 'Subscription locked',
  [tokens.pages.billing.locked.subtitle]:
    'The past-due grace period has ended. Update payment or subscribe to a plan to regain access to the dashboard.',
  [tokens.pages.billing.locked.subtitleStaff]:
    'The past-due grace period has ended. Ask your organization admin to update payment or subscribe to a plan.',
  [tokens.pages.billing.locked.manageCta]: 'Manage subscription',
  [tokens.pages.billing.locked.logoutCta]: 'Log out',
  [tokens.pages.billing.status.active]: 'Active',
  [tokens.pages.billing.status.trialing]: 'Trial',
  [tokens.pages.billing.status.past_due]: 'Past due',
  [tokens.pages.billing.status.incomplete]: 'Incomplete payment',
  [tokens.pages.billing.status.incomplete_expired]: 'Expired (payment)',
  [tokens.pages.billing.status.canceled]: 'Canceled',
  [tokens.pages.billing.status.unpaid]: 'Unpaid',
  [tokens.pages.billing.status.paused]: 'Paused',
  [tokens.pages.billing.status.manual]: 'Manual (ops)',
  [tokens.pages.billing.status.none]: 'No subscription',
  [tokens.pages.billing.cta.current]: 'Current plan',
  [tokens.pages.billing.cta.switchToAnnual]: 'Switch to annual',
  [tokens.pages.billing.cta.switchToMonthly]: 'Switch to monthly',
  [tokens.pages.billing.cta.downgradeScheduled]: 'Downgrade scheduled',
  [tokens.pages.billing.cta.nextCycle]: 'Next cycle',
  [tokens.pages.billing.cta.talkToSales]: 'Talk to sales',
  [tokens.pages.billing.cta.backToStarter]: 'Back to Starter',
  [tokens.pages.billing.cta.downgrade]: 'Downgrade',
  [tokens.pages.billing.cta.subscribe]: 'Subscribe to {{tier}}',
  [tokens.pages.billing.cta.upgrade]: 'Upgrade',
  [tokens.pages.billing.confirm.title]: 'Confirm plan change',
  [tokens.pages.billing.confirm.calculating]: 'Calculating amount…',
  [tokens.pages.billing.confirm.checkoutInfo]:
    'You will be redirected to enter your card and complete the first subscription.',
  [tokens.pages.billing.confirm.scheduledInfo]:
    'No charge now. The change takes effect on {{date}}. You stay on your current plan until then.',
  [tokens.pages.billing.confirm.immediateInfo]:
    'On confirm, we charge the amount below to your saved card (proration / cycle adjustment).',
  [tokens.pages.billing.confirm.amountDueNow]: 'Due now',
  [tokens.pages.billing.confirm.nextInvoices]: 'Upcoming invoices: {{amount}}/{{period}}',
  [tokens.pages.billing.confirm.goCheckout]: 'Go to Checkout · {{amount}}',
  [tokens.pages.billing.confirm.confirmSchedule]: 'Confirm schedule',
  [tokens.pages.billing.confirm.confirmCharge]: 'Confirm and charge {{amount}}',
  [tokens.pages.billing.confirm.impactTitle]: 'What changes with this downgrade',
  [tokens.pages.billing.confirm.impactKeepUntil]:
    'Until {{date}} you keep your current plan features.',
  [tokens.pages.billing.confirm.venueExcess]:
    'The {{tier}} plan allows up to {{limit}} active venue(s). You have {{active}}.',
  [tokens.pages.billing.confirm.venueAutoDeactivate]:
    'Deactivate at least {{excess}} by {{date}}. If you do not, on the switch date we will automatically deactivate {{excess}} venue(s) (random among active).',
  [tokens.pages.billing.confirm.venueManageLink]: 'Manage venues',
  [tokens.pages.billing.confirm.acknowledge]:
    'I understand the impact and want to schedule the downgrade',
  [tokens.pages.billing.starterCancel.title]: 'Back to Starter',
  [tokens.pages.billing.starterCancel.body]:
    'You will be taken to the portal to cancel at the end of the current period. Your paid plan stays active until then. There is no refund for time already paid.',
  [tokens.pages.billing.starterCancel.impactTitle]: 'What happens when you return to Starter',
  [tokens.pages.billing.starterCancel.venueExcess]:
    'Starter allows up to {{limit}} active venue(s). You have {{active}}.',
  [tokens.pages.billing.starterCancel.venueAutoDeactivate]:
    'Deactivate at least {{excess}} before the period ends. Otherwise we will auto-deactivate {{excess}} (random selection).',
  [tokens.pages.billing.starterCancel.acknowledge]:
    'I understand and want to continue to the portal',
  [tokens.pages.billing.starterCancel.openPortal]: 'Open portal',
  [tokens.pages.billing.snackbar.loadError]: 'Could not load subscription',
  [tokens.pages.billing.snackbar.portalError]: 'Failed to open portal',
  [tokens.pages.billing.snackbar.alreadyOnPlan]: 'You are already on this plan and cycle.',
  [tokens.pages.billing.snackbar.previewError]: 'Could not calculate the amount',
  [tokens.pages.billing.snackbar.downgradeScheduled]:
    'Downgrade scheduled for {{date}}. You stay on your current plan until then.',
  [tokens.pages.billing.snackbar.cycleToMonthlyScheduled]:
    'Monthly cycle scheduled for {{date}}. You stay on annual until then.',
  [tokens.pages.billing.snackbar.cycleToAnnual]: 'Switched to annual. Difference charged now.',
  [tokens.pages.billing.snackbar.upgrade]: 'Plan updated. Proration charged now.',
  [tokens.pages.billing.snackbar.updated]: 'Subscription updated',
  [tokens.pages.billing.snackbar.changeError]: 'Failed to change plan',
  [tokens.pages.billing.snackbar.updateCardHint]: 'Update your card in the portal and try again.',
  [tokens.pages.billing.customBanner.name]: 'Custom',
  [tokens.pages.billing.customBanner.body]:
    'Tailored solution: exclusive features on demand, custom integrations, personalized contract and SLA, dedicated account manager.',
  [tokens.pages.billing.tier.starter.tagline]: 'Start with no fixed cost',
  [tokens.pages.billing.tier.starter.h1]: 'Unlimited digital menu',
  [tokens.pages.billing.tier.starter.h2]: 'Prepaid (pay when ordering)',
  [tokens.pages.billing.tier.starter.h3]: 'Payment: card and PIX',
  [tokens.pages.billing.tier.starter.h4]: 'Real-time orders',
  [tokens.pages.billing.tier.starter.h5]: '1 active menu',
  [tokens.pages.billing.tier.starter.h6]: '1 venue',
  [tokens.pages.billing.tier.starter.h7]: 'Email support',
  [tokens.pages.billing.tier.essential.tagline]: 'For teams professionalizing operations',
  [tokens.pages.billing.tier.essential.h1]: 'Everything in Starter',
  [tokens.pages.billing.tier.essential.h2]: 'QR Code per table',
  [tokens.pages.billing.tier.essential.h3]: 'Multiple menus',
  [tokens.pages.billing.tier.essential.h4]: 'Reports and history',
  [tokens.pages.billing.tier.essential.h5]: '1 venue',
  [tokens.pages.billing.tier.essential.h6]: 'Chat support',
  [tokens.pages.billing.tier.pro.tagline]: 'For serious operations',
  [tokens.pages.billing.tier.pro.h1]: 'Everything in Essential',
  [tokens.pages.billing.tier.pro.h2]: 'Postpaid / tab',
  [tokens.pages.billing.tier.pro.h3]: 'Discounts and promotions',
  [tokens.pages.billing.tier.pro.h4]: 'Basic inventory',
  [tokens.pages.billing.tier.pro.h5]: 'AI upsell',
  [tokens.pages.billing.tier.pro.h6]: 'Reports and history',
  [tokens.pages.billing.tier.pro.h7]: 'CSV export',
  [tokens.pages.billing.tier.pro.h8]: 'Visual customization',
  [tokens.pages.billing.tier.pro.h9]: 'Up to 3 venues',
  [tokens.pages.billing.tier.pro.h10]: 'Priority support',
  [tokens.pages.billing.tier.enterprise.tagline]: 'Networks and large operations',
  [tokens.pages.billing.tier.enterprise.h1]: 'Everything in Pro',
  [tokens.pages.billing.tier.enterprise.h2]: 'Network menu',
  [tokens.pages.billing.tier.enterprise.h3]: 'Per-unit pricing',
  [tokens.pages.billing.tier.enterprise.h4]: 'Advanced inventory and waste',
  [tokens.pages.billing.tier.enterprise.h5]: 'Automatic insights',
  [tokens.pages.billing.tier.enterprise.h6]: 'AI demand forecasting',
  [tokens.pages.billing.tier.enterprise.h7]: 'Multi-unit',
  [tokens.pages.billing.tier.enterprise.h8]: 'Network dashboard',
  [tokens.pages.billing.tier.enterprise.h9]: 'POS/ERP API',
  [tokens.pages.billing.tier.enterprise.h10]: 'Up to 10 venues',
  [tokens.pages.billing.tier.enterprise.h11]: 'Assisted onboarding + dedicated SLA',
  [tokens.pages.billing.tier.custom.name]: 'Custom',
  [tokens.pages.billing.tier.custom.tagline]: 'A tailored solution for your business',
};

export default en;
